// services/fundraiserService.js
import axios from 'axios';

const API_BASE_URL = 'https://api.givva.world/api/v1';
const API_BASE_URL_V2 = 'https://api.givva.world/api/v2';
const API_KEY = 'ViRmNzRGVTR5SzJWMDd0eTpEaWFXUFlMMUUqbSVoODlRM2JidENZJFFiJEF0TDVSZkxyYmxtQGIkITEzITFYWFpPeg==';

export const getPublicFundraiser = async (fundraiserId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/fundraisers/${fundraiserId}/public`,
            {
                headers: {
                    'accept': 'application/json',
                    'X-API-KEY': API_KEY,
                },
            }
        );
        return response.data.result;
    } catch (error) {
        console.error('Error fetching fundraiser:', error);
        throw error;
    }
};
export const mpesaDeposit = async (depositAmount,userPhoneNumber,userName,fundraiserId,beneficiaryPhone) => {
    try {
       const data= {
                "amount": depositAmount,
                "phoneNumber": userPhoneNumber,
                "name": userName,
                "fundraiserId": fundraiserId,
                "beneficiaryPhoneNumber": beneficiaryPhone,
                "identifier": null
        };

        const apiHeaders = {
            headers: {
                'accept': 'application/json',
                'X-API-KEY': API_KEY,
            },
        };

        const response = await axios.post(
            `${API_BASE_URL}/payments`,data, apiHeaders);
        return response.data;
    } catch (error) {
        console.error('Error fetching fundraiser:', error);
        throw error;
    }
};

export const payStackDeposit = async (userName,depositAmount,userPhoneNumber,fundraiserId,beneficiaryPhone) => {
    try {
       const data= {
                "name":userName,
                "amount": depositAmount,
                "phoneNumber": userPhoneNumber,
                "fundraiserId": fundraiserId,
                "identifier": null,
                 "beneficiaryPhoneNumber": beneficiaryPhone,
                "paymentMethod": "PAYSTACK",

       };

        const apiHeaders = {
            headers: {
                'accept': 'application/json',
                'X-API-KEY': API_KEY,
            },
        };

        const response = await axios.post(
            `${API_BASE_URL}/payments`,data, apiHeaders);
        return response.data;
    } catch (error) {
        console.error('Error fetching fundraiser:', error);
        throw error;
    }
};
export const makePledge = async (userName,depositAmount,userPhoneNumber,identifier,fundraiserId) => {
    try {
       const data= {
                "name":userName,
                "amount": depositAmount,
                "phoneNumber": userPhoneNumber,
                "identifier": identifier,

       };



        const apiHeaders = {
            headers: {
                'accept': 'application/json',
                'X-API-KEY': API_KEY,
            },
        };

        const response = await axios.post(
            `${API_BASE_URL}/fundraisers/${fundraiserId}/public/pledges`,data, apiHeaders);
        return response.data;
    } catch (error) {
        console.error('Error making a pledge:', error);
        throw error;
    }
};

export const depositConfirmation = async (paymentId) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL}/payments/${paymentId}/status`,
            {
                headers: {
                    'accept': 'application/json',
                    'X-API-KEY': API_KEY,
                },
            }
        );
        return response.data.result;
    } catch (error) {
        console.error('Error fetching fundraiser:', error);
        throw error;
    }
};
export const verifyBeneficiary = async (phoneNumber) => {
    try {
        const response = await axios.get(
            `${API_BASE_URL_V2}/users/search?phoneNumber=${phoneNumber}`,
            {
                headers: {
                    'accept': 'application/json',
                    'X-API-KEY': API_KEY,
                },
            }
        );
        return response.data.result;

        // user found
        // {
        //     "status": 200,
        //     "message": "ok",
        //     "result": {
        //         "name": "name",
        // }
        // }
        //user not found
        // {
        //     "status": 400,
        //     "message": "The user does not exist",
        //     "result": null
        // }
    } catch (error) {
        console.error('Error fetching fundraiser:', error);
        throw error;
    }
};